import React from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How do apps run on blockchain?",
    answer: `<p>Blockchain apps operate on a distributed ledger, which speeds up transactions compared to regular apps. In these apps, a network of nodes approves transactions, making the process faster and more efficient.</p>`,
  },
  {
    question: "How much does it cost to build a blockchain app?",
    answer: `<p>The expenses for creating a blockchain app usually vary between $40,000 to $300,000 or more. It is usually influenced by factors like design, features, and complexity., However, it's advisable to consult with a professional blockchain app development company to estimate a precise cost according to your project.</p>`,
  },
  {
    question: "How much does it cost to create a blockchain app?",
    answer: `<p>Following are the different scales of blockchain app development costing as per the complexity of the app</p> 
    <table class="table">
    <thead>
      <tr>
        <th scope="col">App Complexity</th>
        <th scope="col">Estimated Cost</th>
        <th scope="col">Timeline</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>Low</td>
        <td>$40,000 to $60,000</td>
        <td>3 to 6 months</td>
      </tr>
      <tr>
        <td>Medium</td>
        <td>$60,000 to $130,000</td>
        <td>6 to 8 months</td>
      </tr>
      <tr>
        <td>High</td>
        <td>$130,000 to $280,000</td>
        <td>10+ months</td>
      </tr>
    </tbody>
  </table> 
  </p>`,
  },
  {
    question: "How long does it take to build a blockchain app?",
    answer: `<p>2 - 7+ months, based on the complexity of your application. However, the timeline for each project can be different according to the scalability of the projects. There are multiple factors involved that can impact the overall duration of the development of your blockchain app.</p>`,
  },
  {
    question: "How do I choose a blockchain development company?",
    answer: `<p>Clearly define your goals for your blockchain initiative. It will help you in choosing a blockchain application development company with the appropriate skills. Ensure that the company has previous experience in handling similar types of projects. Moreover, review case studies, client feedback, or a portfolio to verify their expertise.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div
      className="faq_loc p-100 tekrevol_dark_bg home"
      style={{ background: "#F8F8FB" }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Blockchain App Development FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
